/* */ 
"use strict";
var core_1 = require('@angular/core');
var lang_1 = require('../facade/lang');
var exceptions_1 = require('../facade/exceptions');
var NgForRow = (function() {
  function NgForRow($implicit, index, count) {
    this.$implicit = $implicit;
    this.index = index;
    this.count = count;
  }
  Object.defineProperty(NgForRow.prototype, "first", {
    get: function() {
      return this.index === 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NgForRow.prototype, "last", {
    get: function() {
      return this.index === this.count - 1;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NgForRow.prototype, "even", {
    get: function() {
      return this.index % 2 === 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NgForRow.prototype, "odd", {
    get: function() {
      return !this.even;
    },
    enumerable: true,
    configurable: true
  });
  return NgForRow;
}());
exports.NgForRow = NgForRow;
var NgFor = (function() {
  function NgFor(_viewContainer, _templateRef, _iterableDiffers, _cdr) {
    this._viewContainer = _viewContainer;
    this._templateRef = _templateRef;
    this._iterableDiffers = _iterableDiffers;
    this._cdr = _cdr;
  }
  Object.defineProperty(NgFor.prototype, "ngForOf", {
    set: function(value) {
      this._ngForOf = value;
      if (lang_1.isBlank(this._differ) && lang_1.isPresent(value)) {
        try {
          this._differ = this._iterableDiffers.find(value).create(this._cdr, this._ngForTrackBy);
        } catch (e) {
          throw new exceptions_1.BaseException("Cannot find a differ supporting object '" + value + "' of type '" + lang_1.getTypeNameForDebugging(value) + "'. NgFor only supports binding to Iterables such as Arrays.");
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NgFor.prototype, "ngForTemplate", {
    set: function(value) {
      if (lang_1.isPresent(value)) {
        this._templateRef = value;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NgFor.prototype, "ngForTrackBy", {
    set: function(value) {
      this._ngForTrackBy = value;
    },
    enumerable: true,
    configurable: true
  });
  NgFor.prototype.ngDoCheck = function() {
    if (lang_1.isPresent(this._differ)) {
      var changes = this._differ.diff(this._ngForOf);
      if (lang_1.isPresent(changes))
        this._applyChanges(changes);
    }
  };
  NgFor.prototype._applyChanges = function(changes) {
    var _this = this;
    var recordViewTuples = [];
    changes.forEachRemovedItem(function(removedRecord) {
      return recordViewTuples.push(new RecordViewTuple(removedRecord, null));
    });
    changes.forEachMovedItem(function(movedRecord) {
      return recordViewTuples.push(new RecordViewTuple(movedRecord, null));
    });
    var insertTuples = this._bulkRemove(recordViewTuples);
    changes.forEachAddedItem(function(addedRecord) {
      return insertTuples.push(new RecordViewTuple(addedRecord, null));
    });
    this._bulkInsert(insertTuples);
    for (var i = 0; i < insertTuples.length; i++) {
      this._perViewChange(insertTuples[i].view, insertTuples[i].record);
    }
    for (var i = 0,
        ilen = this._viewContainer.length; i < ilen; i++) {
      var viewRef = this._viewContainer.get(i);
      viewRef.context.index = i;
      viewRef.context.count = ilen;
    }
    changes.forEachIdentityChange(function(record) {
      var viewRef = _this._viewContainer.get(record.currentIndex);
      viewRef.context.$implicit = record.item;
    });
  };
  NgFor.prototype._perViewChange = function(view, record) {
    view.context.$implicit = record.item;
  };
  NgFor.prototype._bulkRemove = function(tuples) {
    tuples.sort(function(a, b) {
      return a.record.previousIndex - b.record.previousIndex;
    });
    var movedTuples = [];
    for (var i = tuples.length - 1; i >= 0; i--) {
      var tuple = tuples[i];
      if (lang_1.isPresent(tuple.record.currentIndex)) {
        tuple.view = this._viewContainer.detach(tuple.record.previousIndex);
        movedTuples.push(tuple);
      } else {
        this._viewContainer.remove(tuple.record.previousIndex);
      }
    }
    return movedTuples;
  };
  NgFor.prototype._bulkInsert = function(tuples) {
    tuples.sort(function(a, b) {
      return a.record.currentIndex - b.record.currentIndex;
    });
    for (var i = 0; i < tuples.length; i++) {
      var tuple = tuples[i];
      if (lang_1.isPresent(tuple.view)) {
        this._viewContainer.insert(tuple.view, tuple.record.currentIndex);
      } else {
        tuple.view = this._viewContainer.createEmbeddedView(this._templateRef, new NgForRow(null, null, null), tuple.record.currentIndex);
      }
    }
    return tuples;
  };
  NgFor.decorators = [{
    type: core_1.Directive,
    args: [{
      selector: '[ngFor][ngForOf]',
      inputs: ['ngForTrackBy', 'ngForOf', 'ngForTemplate']
    }]
  }];
  NgFor.ctorParameters = [{type: core_1.ViewContainerRef}, {type: core_1.TemplateRef}, {type: core_1.IterableDiffers}, {type: core_1.ChangeDetectorRef}];
  return NgFor;
}());
exports.NgFor = NgFor;
var RecordViewTuple = (function() {
  function RecordViewTuple(record, view) {
    this.record = record;
    this.view = view;
  }
  return RecordViewTuple;
}());
